import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.093 34.004a.886.886 0 0 1 .767-.484 180.55 180.55 0 0 0 8.407-.416 4.432 4.432 0 0 0 4.093-4.031c.245-2.776.367-5.694.367-8.755a99.8 99.8 0 0 0-.364-8.722 4.432 4.432 0 0 0-4.101-4.033c-5.076-.36-9.478-.54-13.205-.54-3.736 0-8.176.18-13.317.543A4.432 4.432 0 0 0 6.637 11.6a99.785 99.785 0 0 0-.364 8.718c0 3.057.122 5.972.366 8.745a4.432 4.432 0 0 0 4.098 4.031c2.822.203 5.623.342 8.4.419a.886.886 0 0 1 .766.484l3.307 6.5a.886.886 0 0 0 1.58 0l3.303-6.493Zm-1.723 7.297a2.66 2.66 0 0 1-4.74 0l-3.069-6.032a192.55 192.55 0 0 1-7.951-.406 6.204 6.204 0 0 1-5.737-5.644 101.504 101.504 0 0 1-.373-8.9c0-3.1.124-6.057.371-8.874a6.205 6.205 0 0 1 5.744-5.647c5.18-.365 9.66-.548 13.442-.548 3.772 0 8.215.182 13.33.545a6.205 6.205 0 0 1 5.742 5.646c.247 2.819.371 5.778.371 8.877 0 3.112-.125 6.082-.374 8.91a6.204 6.204 0 0 1-5.73 5.644 182.27 182.27 0 0 1-7.962.406L26.37 41.3Zm-9.46-27.22h14.18c1.183 0 1.183 1.774 0 1.774H16.91c-1.183 0-1.183-1.773 0-1.773Zm0 5.319h14.18c1.183 0 1.183 1.773 0 1.773H16.91c-1.183 0-1.183-1.773 0-1.773Zm0 5.318h6.204c1.181 0 1.181 1.773 0 1.773h-6.205c-1.182 0-1.182-1.773 0-1.773Z",
    fill: "currentColor"
  }));
};

var SvgContact = styled(SvgComponent).withConfig({
  displayName: "Contact__SvgContact",
  componentId: "sc-x6xu1o-0"
})(["", " ", ""], size, color);
export default SvgContact;